/**
 * ProductSlider Component
 */
(function (itxApp) {

    'use strict';

    /**
     * Product Slider for showing related and latest viewed
     * @name productSliderCtrl
     * @type ItxProductSliderCmpCtrl
     */
    var ItxProductSliderCmp = {
        bindings: {
            product: '<',
            products: '<',
            numberSlidesXs: '<',
        },
        controller: ItxProductSliderCmpCtrl,
        controllerAs: 'productSliderCtrl',
        templateUrl: 'ItxProductSlider.html'
    };

    ItxProductSliderCmpCtrl.$inject = ['$scope', '$timeout', 'ItxConstants', 'ItxUtilsFct', 'ItxScreenSizeSvc'];

    function ItxProductSliderCmpCtrl($scope, $timeout, ItxConstants, ItxUtilsFct, ItxScreenSizeSvc) {
        var _this = this;

        _this.ItxUtilsFct = ItxUtilsFct;
        _this.sliderConfig = ItxConstants.sliders.related;
        
        //TODO: improve slider config system
        if (_this.numberSlidesXs) {
            _this.sliderConfig.responsive[2].settings.item = _this.numberSlidesXs;
        }

        _this.$onChanges = function (changes) {
            if (changes && changes.products && _.isArray(changes.products.previousValue)) {
                $scope.$broadcast('itx-slider:go-to-slide', 0);
            }
        };

        _this.next = function () {
            $scope.$broadcast('itx-slider:next');
            $timeout(function () { $scope.$broadcast('scrollstop'); }, 500);
        };

        _this.prev = function () {
            $scope.$broadcast('itx-slider:prev');
            $timeout(function () { $scope.$broadcast('scrollstop'); }, 500);
        };

        _this.isNavVisible = function () {
            if( !_this.products){
                return false;
            } 
            if ((ItxScreenSizeSvc.is('md') && _this.products.length > 2) ||
                (ItxScreenSizeSvc.is('lg') && _this.products.length > 4)) {
                return true;
            } else {
                return false;
            }
        };
    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxProductSlider', ItxProductSliderCmp);

    itxApp.common.ItxProductSliderCmp = ItxProductSliderCmp;
    itxApp.common.ItxProductSliderCmpCtrl = ItxProductSliderCmpCtrl;

})(window.itxApp);
